import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";

const languages = [
  { code: "de", name: "Deutsch" },
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
  { code: "it", name: "Italiano" },
];

export default function LanguageRender(props) {
  const selectedLanguage = (props.language ?? "de").split("-")[0];

  return (
    <Menu
      anchorEl={props.anchorLang}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      data-testid="language"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={props.isLanguageOpen}
      onClose={props.handleLanguageClose}
    >
      {languages.map((language) => (
        <MenuItem
          key={language.code}
          data-testid={language.code + "Button"}
          sx={{
            gap: "10px",
            color:
              selectedLanguage === language.code
                ? "secondary.main"
                : "darkblue.main",
            ":hover": { color: "secondary.main" },
          }}
          onClick={() => {
            props.changeLanguage(language.code);
            props.handleLanguageClose();
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: "500", minWidth: "24px" }}
          >
            {language.code.toUpperCase()}
          </Typography>
          <Typography variant="body2">{language.name}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
}
